import styled from 'styled-components';
import React, { PropsWithChildren } from 'react';

export type HeadingType = 'h1' | 'h2';

interface VariantProps {
  as?: HeadingType;
}

export interface ArticleHeadingProps extends VariantProps {
  className?: string;
}

function ArticleHeading({
  as = 'h1',
  children,
  className,
}: PropsWithChildren<ArticleHeadingProps>) {
  const mapHeadingTypeToComponent = {
    h1: ArticleH1Css,
    h2: ArticleH2Css,
  };
  const Heading = mapHeadingTypeToComponent[as];

  return <Heading className={className}>{children}</Heading>;
}

const ArticleH1Css = styled.h1`
  ${p => p.theme.getFontStyle('primary', 'semiBold')}
  color: ${p => p.theme.colors.black};
  font-size: ${p => p.theme.typography.text3Xl};
  margin: 0;
`;

const ArticleH2Css = styled.h2`
  ${p => p.theme.getFontStyle('primary', 'semiBold')}
  font-size: ${p => p.theme.typography.textXl};
  margin: 0;
`;

export default ArticleHeading;
